import Axios from "./axios";

const resource = "merchant-billing-informations";

export default {
	create(data) {
		return Axios.post(`${resource}`, data);
	}
}